import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './AdminNavbar.css'; // <-- Importación del diseño UI/UX

const AdminNavbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const navigate = useNavigate();

  // Detectar cambios de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false); // Cerrar menú en desktop
        document.body.classList.remove('menu-open');
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  }, [location]);

  // Controlar scroll del body cuando el menú está abierto
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMobile) setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
    closeMenu();
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <>
      {/* Overlay para móvil */}
      {isMobile && isMenuOpen && (
        <div className="admin-menu-overlay" onClick={closeMenu}></div>
      )}

      <nav className={`admin-navbar ${isMenuOpen ? 'active' : ''}`}>
        <div className="admin-nav-container">
          
          {/* Logo */}
          <div className="admin-nav-logo">
            <Link to="/admin" onClick={closeMenu}>
              <span className="logo-icon">☕</span>
              <div className="logo-text-wrapper">
                <span className="logo-text">Román Valderrábano</span>
                <span className="logo-subtext">El Catador <span className="logo-badge">Admin</span></span>
              </div>
            </Link>
          </div>

          {/* Menú de navegación */}
          <div className="admin-nav-menu">
            <p className="nav-section-title">MENÚ PRINCIPAL</p>
            <Link to="/admin" className={`admin-nav-link ${isActive('/admin')}`} onClick={closeMenu}>
              <span className="nav-icon">📊</span> Dashboard
            </Link>
            <Link to="/admin/ventas" className={`admin-nav-link ${isActive('/admin/ventas')}`} onClick={closeMenu}>
              <span className="nav-icon">💰</span> Ventas
            </Link>
            <Link to="/admin/productos" className={`admin-nav-link ${isActive('/admin/productos')}`} onClick={closeMenu}>
              <span className="nav-icon">📦</span> Productos
            </Link>
            <Link to="/admin/tours" className={`admin-nav-link ${isActive('/admin/tours')}`} onClick={closeMenu}>
              <span className="nav-icon">🎫</span> Tours
            </Link>
            <Link to="/admin/entregas" className={`admin-nav-link ${isActive('/admin/entregas')}`} onClick={closeMenu}>
              <span className="nav-icon">🚚</span> Entregas
            </Link>
            
            <p className="nav-section-title mt-4">MARKETING Y CONTROL</p>
            <Link to="/admin/promociones" className={`admin-nav-link ${isActive('/admin/promociones')}`} onClick={closeMenu}>
              <span className="nav-icon">🎁</span> Promociones
            </Link>
            <Link to="/admin/cafe-verde" className={`admin-nav-link ${isActive('/admin/cafe-verde')}`} onClick={closeMenu}>
              <span className="nav-icon">🌱</span> Café Verde
            </Link>
            <Link to="/admin/correos" className={`admin-nav-link ${isActive('/admin/correos')}`} onClick={closeMenu}>
              <span className="nav-icon">📧</span> Correos
            </Link>
          </div>

          {/* Información del usuario */}
          <div className="admin-user-info">
            <div className="user-avatar-wrapper">
              <span className="user-avatar">👤</span>
              <div className="user-details">
                <span className="user-name">{user?.nombre || 'Administrador'}</span>
                <span className="user-rol">{user?.rol || 'Gerencia'}</span>
              </div>
            </div>
            <button 
              onClick={handleLogout} 
              className="admin-logout-btn" 
              title="Cerrar sesión"
            >
              🚪
            </button>
          </div>
        </div>
      </nav>

      {/* Botón de menú hamburguesa para móvil (Fijo arriba a la derecha) */}
      {isMobile && (
        <button 
          className={`admin-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Menú"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      )}
    </>
  );
};

export default AdminNavbar;